/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var CategoryType;

(function (CategoryType) {
  CategoryType["CONSTRUCTION"] = "construction";
  CategoryType["HR_PLATFORMS"] = "hr_platforms";
  CategoryType["MOBILITY"] = "mobility";
})(CategoryType || (CategoryType = {}));